import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgLinkOutFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 3h-5a3.001 3.001 0 0 0-2.83 2H6.4A2.4 2.4 0 0 0 4 7.4v11.2A2.4 2.4 0 0 0 6.4 21h11.2a2.4 2.4 0 0 0 2.4-2.4v-4.77A3.001 3.001 0 0 0 22 11V6a3 3 0 0 0-3-3Zm0 2a1 1 0 0 1 .993.883L20 6v5a1 1 0 0 1-1.993.117L18 11V8.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L16.586 7H14a1 1 0 0 1-.117-1.993L14 5h5Z", fill: color }));
};
export default factorySvgIcon(SvgLinkOutFilled);
//# sourceMappingURL=SvgLinkOutFilled.js.map